import React from 'react';

import { DatePicker } from 'antd';

const { RangePicker } = DatePicker;

const RangePickerCustom = (props) => {
  return (
    <RangePicker {...props} />
  );
};

export default RangePickerCustom;